import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import { Variables } from "../../styles/Variables";
import IconClose from "../../components/Icons/IconClose";

import { Modal, Close, Content, InfoContent, InfoContentMoreInfo } from "./styles";

const ModalInformation = ({ modalOpen, setModalOpen, children, moreInfo, close, notClose }) => {
  const router = useNavigate();
  return (
    modalOpen && (
      <Modal onClick={notClose || close ? null : () => setModalOpen(false)}>
        <Content onClick={(event) => event.stopPropagation()}>
          {!notClose && (
            <Close
              onClick={
                close
                  ? () => {
                      setModalOpen(false);
                      router(close);
                    }
                  : () => setModalOpen(false)
              }
            >
              <IconClose color={Variables.colorBlackDark} width={25} height={25} />
            </Close>
          )}
          {moreInfo ? <InfoContentMoreInfo>{children}</InfoContentMoreInfo> : <InfoContent>{children}</InfoContent>}
        </Content>
      </Modal>
    )
  );
};

ModalInformation.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  children: PropTypes.node.isRequired,
  moreInfo: PropTypes.bool,
  close: PropTypes.string,
  notClose: PropTypes.bool,
};

export default ModalInformation;
